module.exports = __webpack_public_path__ + "static/media/FOTO RETOQUE.50b9a21b.jpg";